import { OrderItem } from './OrderItem'
import { ProductImage } from 'utils/imageUtils'

interface Product {
  image?: string | ProductImage // Old format: string, or Cart/Order format: ProductImage object
  images?: ProductImage[] // New format: array of image objects
  title: string
}

interface StatusHistoryType {
  status: string
  changedAt: string | number | Date
}

interface OrderItems {
  discount: number
  id: string
  orderId: string
  ownerId: string
  product: Product
  productId: string
  quantity: number
  price: number
  shipmentTrackingCode: number | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

interface OrderItemsProp {
  orderItems: OrderItems
}
export const OrderReportListItem = ({ orderItems }: OrderItemsProp) => {
  const items = [orderItems]
  return (
    <li className='order-report-list-item my-6'>
      <ul>
        {items.map((item) => (
          <OrderItem orderItem={item} key={item.id} />
        ))}
      </ul>
    </li>
  )
}
